import { createSlice } from '@reduxjs/toolkit';
export const PaymentMethodUpdateStatuses = {
  IDLE: 'idle',
  PENDING: 'pending',
  POLLING: 'polling',
  COMPLETED_WITHOUT_TARGET: 'completedWithoutTarget'
};
const initialState = {
  status: PaymentMethodUpdateStatuses.IDLE
};
const paymentMethodUpdateSlice = createSlice({
  name: 'paymentMethodUpdate',
  initialState,
  reducers: {
    startPaymentMethodUpdate: (_state, action) => ({
      status: PaymentMethodUpdateStatuses.PENDING,
      target: action.payload
    }),
    completePaymentMethodUpdate: state => {
      if (state.status === PaymentMethodUpdateStatuses.PENDING) {
        return {
          status: PaymentMethodUpdateStatuses.POLLING,
          target: state.target
        };
      }
      if (state.status === PaymentMethodUpdateStatuses.IDLE) {
        return {
          status: PaymentMethodUpdateStatuses.COMPLETED_WITHOUT_TARGET
        };
      }
      return state;
    },
    clearPaymentMethodUpdate: () => ({
      status: PaymentMethodUpdateStatuses.IDLE
    })
  }
});
export const selectPaymentMethodUpdateStatus = state => state.paymentMethodUpdate.status;
export const selectPaymentMethodUpdateTarget = state => {
  const slice = state.paymentMethodUpdate;
  return slice.status === PaymentMethodUpdateStatuses.PENDING || slice.status === PaymentMethodUpdateStatuses.POLLING ? slice.target : null;
};
export const {
  startPaymentMethodUpdate,
  completePaymentMethodUpdate,
  clearPaymentMethodUpdate
} = paymentMethodUpdateSlice.actions;
export default paymentMethodUpdateSlice.reducer;